export default "../../src/img/patterns/c2-150x150.jpeg";